// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PnMDV","content":"styles_content__Ia0vJ","title":"styles_title__Ty4eH","description":"styles_description__Qoj--","image":"styles_image__nYPnq"};